// Thumbnail row for the product gallery: clicking a thumbnail brings that photo into view,
// and swiping the gallery keeps the highlighted thumbnail in sync.
class SProductThumbs extends HTMLElement {
  connectedCallback() {
    const gallery = this.querySelector('[data-product-gallery]');
    const thumbs = [...this.querySelectorAll('[data-thumb]')];
    if (!gallery || thumbs.length === 0) return;
    const slides = [...gallery.querySelectorAll(':scope > [data-gallery-slide]')];

    const setActive = (index) => {
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        const slide = slides[index];
        if (!slide) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const offset = slide.getBoundingClientRect().left - gallery.getBoundingClientRect().left;
        gallery.scrollBy({ left: offset, behavior: reduce ? 'auto' : 'smooth' });
        setActive(index);
      });
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(slides.indexOf(entry.target));
        });
      },
      { root: gallery, threshold: 0.6 }
    );
    slides.forEach((slide) => this.observer.observe(slide));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('s-product-thumbs')) customElements.define('s-product-thumbs', SProductThumbs);
